"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.setNotificationCount = function (count) {
    return toolkit_1.createAction(constants_1.SET_NOTIFICATION_COUNT)(count);
};
exports.setNotificationsSeen = function (seen) {
    return toolkit_1.createAction(constants_1.SET_NOTIFICATIONS_SEEN)(seen);
};
// deprecated
exports.setToastMessage = function (message) { return toolkit_1.createAction(constants_1.TOAST_MESSAGE)(message); };
exports.setFilledToastMessage = function (message) {
    return toolkit_1.createAction(constants_1.FILLED_TOAST_MESSAGE)(message);
};
exports.setNotificationMessage = function (_a) {
    var level = _a.level, message = _a.message;
    return toolkit_1.createAction(constants_1.SET_NOTIFICATION_MESSAGE)({ level: level, message: message });
};
exports.resetNotificationMessage = function () { return toolkit_1.createAction(constants_1.SET_NOTIFICATION_MESSAGE)(null); };
//# sourceMappingURL=actions.js.map